const FacebookDataDeletion = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">
        Facebook Data Deletion Instructions
      </h1>

      <p className="mb-4">
        If you would like to delete your data associated with the
        AllAboutTheOptions application, please follow these steps:
      </p>

      <ol className="list-decimal list-inside space-y-2 mb-6">
        <li>Log into your account on our website.</li>
        <li>Navigate to Account Settings.</li>
        <li>Select "Delete My Data".</li>
      </ol>

      <p>
        Or send a deletion request to:{" "}
        <a
          href="mailto:support@itsallabouttheoptions.com"
          className="text-blue-600 underline"
        >
          support@itsallabouttheoptions.com
        </a>
      </p>
    </div>
  );
};

export default FacebookDataDeletion;
